export default __webpack_public_path__ + "static/media/java2016solo.aca930eb.jpg";